<app-modal-layout
    *transloco="let tManageFields; read: 'manage_fields'"
    [containerLayout]="containerLayout"
    [showLoader]="showLoader"
    [errors]="errors"
    (closeModal)="forceWithValidation()"
    class="block md:w-[31.25rem]"
>
    <ng-container title>{{ tManageFields(editMode ? 'manage_field' : 'add_field') }}</ng-container>
    <ng-container subtitle
        ><div class="w-3/4">{{ tManageFields('add_field_subtitle') }}</div></ng-container
    >
    <div [formGroup]="formGroup" class="mt-4">
        <div class="flex w-full flex-col gap-4">
            <div class="flex w-full gap-4 flex-col sm:flex-row">
                @if (data.workspace_guid) {
                    <div class="flex flex-col flex-1 sm:w-[47%] w-full">
                        <div class="body-1">{{ tManageFields('workspace') }}</div>
                        <app-tb-select
                            class="flex-1 text-nowrap overflow-ellipsis"
                            formControlName="workspace"
                        >
                            @for (workspace of workspacesForMove; track workspace.guid) {
                                <app-tb-option
                                    [icon]="workspace.icon.value"
                                    [iconColor]="workspace.color.value"
                                    [value]="workspace.guid"
                                >
                                    {{ workspace.name.value }}
                                </app-tb-option>
                            }
                        </app-tb-select>
                    </div>
                }
                @if (availableFieldTypes$ | async; as types) {
                    <div class="flex flex-col flex-1 md:w-[47%] w-full">
                        <div class="body-1">{{ tManageFields('field_type') }}</div>
                        <app-tb-select
                            [value]="data.workspace_guid"
                            class="flex-1"
                            formControlName="fieldType"
                        >
                            @for (type of types; track type.guid) {
                                <app-tb-option [icon]="type.icon" [value]="type.guid">
                                    {{ type.name }}
                                </app-tb-option>
                            }
                        </app-tb-select>
                    </div>
                }
            </div>
            <app-tb-input
                class="w-full"
                *transloco="let tCommonErrors; read: 'common_errors'"
                [label]="tManageFields('field_name')"
                [placeholder]="tManageFields('name_placeholder')"
                [errors]="[
                    { code: 'required', message: tManageFields('incorrect_input') },
                    { code: 'pattern', message: tCommonErrors('name_whitespace_input') },
                ]"
                formControlName="columnName"
            ></app-tb-input>
        </div>
        <div class="w-full flex flex-row justify-start items-center min-h-4">
            @if (supportNewSettings) {
                <ng-container [ngTemplateOutlet]="content"></ng-container>
            } @else {
                <ng-container
                    *appEnv="'prod'; visible: false"
                    [ngTemplateOutlet]="content"
                ></ng-container>
            }
            <ng-template #content>
                <app-add-field-content
                    (fieldChanged)="changedValue($event)"
                    (configurationChanged)="configurationChanged($event)"
                    (valid)="isColumnContentValid = $event"
                    [fieldType]="field.field_type_code"
                    [field]="field"
                    class="my-4"
                ></app-add-field-content>
            </ng-template>
        </div>
        <div class="flex items-start mb-4">
            <app-tb-toggle formControlName="onTop"></app-tb-toggle>
            <div class="mt-1 ml-4">
                <div class="body-1">{{ tManageFields('on_top') }}</div>
                <div class="caption-1 text-textLight">
                    {{ tManageFields('on_top_description') }}
                </div>
            </div>
        </div>
        <div class="flex items-start">
            <app-tb-toggle formControlName="required"></app-tb-toggle>
            <div class="mt-1 ml-4">
                <div class="body-1">{{ tManageFields('required_field') }}</div>
                <div class="caption-1 text-textLight">
                    {{ tManageFields('required_field_description') }}
                </div>
                @if (isRequired && data.field_type_code !== FieldTypes.WATCH) {
                    <div>
                        <span class="body-1 mb-1">{{ tManageFields('default_value') }}</span>
                        @if (supportNewContainer) {
                            <!--TODO: needs additional outclick to save data-->
                            <app-input-cell-container
                                [field]="field"
                                [extraData]="{ hide_closed_options: true }"
                                appearance="create_record"
                                formControlName="defaultValue"
                            ></app-input-cell-container>
                        } @else {
                            <!--TODO: convert to form control-->
                            <app-cell-container
                                [field]="field"
                                [guid]="field.guid"
                                [value]="field.default_value ?? ''"
                                [fieldTypes]="(allFieldTypesDictionary$ | async) || {}"
                                (cellValueChanged)="defaultValueChanged($event)"
                            ></app-cell-container>
                        }
                    </div>
                }
            </div>
        </div>
        @if (shareAvailable) {
            <div class="mt-4 flex flex-col">
                <div class="body-2">{{ tManageFields('share_field') }}</div>
                <span class="pb-2 caption-1 text-textLight">{{
                    tManageFields('share_field_description')
                }}</span>
                <app-tb-select
                    formControlName="sharedWorkspaces"
                    [placeholder]="tManageFields('share_field_select_placeholder')"
                    [value]="data.shared_with_workspaces"
                    [multiple]="true"
                    [shaded]="true"
                >
                    @for (workspace of workspacesForShare; track workspace.guid) {
                        <app-tb-option
                            [iconColor]="workspace.color.value"
                            [icon]="workspace.icon.value"
                            [value]="workspace.guid"
                        >
                            {{ workspace.name.value }}
                        </app-tb-option>
                    }
                </app-tb-select>
            </div>
        }
        <!--TODO: add accordion-->
    </div>
    <ng-container buttons>
        <app-modal-layout-buttons
            *transloco="let tButtons; read: 'buttons'"
            class="flex justify-end"
            [primary]="true"
            [action]="true"
            [cancel]="editMode && !!field.operation_code_entity?.delete"
            [primaryLonger]="true"
        >
            <app-tb-button action appearance="text" icon="custom_arrow_back" (click)="close()">
                {{ tButtons('back') }}
            </app-tb-button>
            <app-tb-button
                cancel
                *appOperation="field.operation_code_entity; target: 'delete'; condition: editMode"
                appearance="text"
                icon="close"
                color="secondary"
                (click)="delete()"
                class="min-w-[6.25rem]"
            >
                {{ tButtons('delete') }}
            </app-tb-button>
            <div primary class="flex gap-1">
                <app-tb-button (click)="saveColumn()" class="flex-1">
                    {{ tButtons('save') }}
                </app-tb-button>
                @if (allFieldTypesDictionary$ | async; as fieldTypes) {
                    @if (formGroup.controls.fieldType.value; as guid) {
                        <app-tb-button-with-options
                            *appOperation="fieldTypes[guid]?.operation_code_entity; target: 'copy'"
                            [template]="fieldSaveOptions"
                            xPosition="before"
                            yPosition="above"
                        ></app-tb-button-with-options>
                    }
                }

                <ng-template #fieldSaveOptions let-containerLayout="containerLayout">
                    <app-tb-menu-list
                        [containerLayout]="containerLayout"
                        [insideModalLayout]="true"
                    >
                        <app-tb-menu-list-item (click)="saveAndDuplicate()">
                            {{ tManageFields('save_and_duplicate') }}
                        </app-tb-menu-list-item>
                        <app-tb-menu-list-item (click)="saveAndCreateAnotherOne()">
                            {{ tManageFields('save_and_start') }}
                        </app-tb-menu-list-item>
                    </app-tb-menu-list>
                </ng-template>
            </div>
        </app-modal-layout-buttons>
    </ng-container>
</app-modal-layout>
